import template from './settings-recognitions.html';
import controller from './settings-recognitions.controller';
import './settings-recognitions.scss';

export default {
  require: {
    settings: '^settings'
  },
  template,
  controller,
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/settings/screens/settings-recognitions/settings-recognitions.component.js